export default function PHP_date() {
  return (
    <div>
      <h1>PHP_date</h1>
    </div>
  );
}
